import { useState, useEffect } from 'react'

const usePaginating = (max = 5, total, totalPages) => {
	const [itemsPerPage, setItemsPerPage] = useState(max)
	const [sortConfig, setSortConfig] = useState({ key: 'modified', direction: false })
	const [currentPage, setCurrentPage] = useState(1)
	const [totalPage, setTotalPage] = useState(10)

	function handleCurrnetInput(e) {
		const value = e.target?.value === "" ? "" : e.target.value
		const current = parseInt(value)

		if(totalPages === 0) {
			setCurrentPage(1)
		} else if(current > totalPages) {	
			setCurrentPage(totalPages)
		} else if(current < 1) {
			setCurrentPage(1)
		} else {
			setCurrentPage(current)
		}
	}

	function goToPrev() {

		if (currentPage === 1) {
			return
		}

		handleCurrnetInput({
			target: {
				value: currentPage - 1
			}
		})
	}

	function goToNext() {
		if (currentPage === totalPages) {
			return
		}

		handleCurrnetInput({
			target: {
				value: currentPage + 1
			}
		})
	}
	function getPageStart(pageSize, pageNr) {
		return pageSize * pageNr;
	};
	const start = Math.max(
		getPageStart(itemsPerPage, currentPage ? currentPage - 1 : 0),
		0
	);
	const end = Math.min(
		getPageStart(itemsPerPage, currentPage ? currentPage : 0),
		total
	);

	const pageLabel = `${start + 1} - ${end}`

	return {
		itemsPerPage,
		currentPage,
		totalPage,
		sortConfig,
		setSortConfig,
		setItemsPerPage,
		setCurrentPage,
		setTotalPage,
		goToPrev,
		goToNext,
		handleCurrnetInput,
		handleCurrentInput: handleCurrnetInput,
		pageLabel,
	}
}

export default usePaginating
